import { escapeHTML } from '@caresend/utils';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle, faInfoCircle, faCheckCircle } from '@fortawesome/sharp-regular-svg-icons';
import { ToastProgrammatic } from 'buefy';
import { addSentryBreadcrumb } from '../sentry.js';

const getToastIconHtmlString = (iconDefinition) => { var _a; return (_a = icon(iconDefinition)) === null || _a === void 0 ? void 0 : _a.html[0]; };
const getToastIcon = (type) => {
    switch (type) {
        case 'is-success':
            return getToastIconHtmlString(faCheckCircle);
        case 'is-info':
            return getToastIconHtmlString(faInfoCircle);
        case 'is-danger':
            return getToastIconHtmlString(faExclamationCircle);
    }
};
const getToastMessageHTML = (type, messageString) => {
    /** HTML not supported within passed string to prevent XSS attacks */
    const escapedMessage = escapeHTML(messageString);
    return `<div class="toast__content">
    ${getToastIcon(type)}
    <div class="toast__message">${escapedMessage}</div>
  </div>`;
};
/**
 * Internal helper to open toast. All options can be overridden except for
 * message and type.
 */
const openToast = (
/** Types (colors) from Buefy */
type, messageString, options) => {
    const message = getToastMessageHTML(type, messageString);
    ToastProgrammatic.open({
        duration: 5000,
        pauseOnHover: true,
        ...options,
        message,
        type,
    });
    addSentryBreadcrumb(messageString, 'toast');
};

export { getToastIcon, getToastMessageHTML, openToast };
